import React, { useState, useEffect } from "react";
import { SiteLink } from "../../components";
import { useStore } from "../../store";
import { FaPlus, FaMinus } from "react-icons/fa";
import { BiSearchAlt } from "react-icons/bi";
import { SearchBar } from "./searchBar2";

export function NavBarHori({ currentLocation, onCloseMenu }) {
  const { state } = useStore();
  const menu = state.menu || { items: [] };
  const [searchOpened, setSearchOpened] = useState(false);

  const menuItemElts = menu.items.map((item, index) => (
    <React.Fragment key={index}>
      {index > 0 && <li className='horizontal_menu_separator'>|</li>}
      <MenuItem
        item={item}
        onCloseMenu={onCloseMenu}
        currentLocation={currentLocation}
      />
    </React.Fragment>
  ));

  // return (
  //   <div className='horizontal_menu'>
  //     <ul className='horizontal_menu_ul'>{menuItemElts}</ul>
  //   </div>
  // );
  if (searchOpened) {
    return (
      <div className='horizontal_menu'>
        <ul className='horizontal_menu_ul'>{menuItemElts} </ul>
        {/* {horizontalMenuActions} */}
        <div
          className={`search_container ${
            searchOpened ? "search_container_open" : ""
          }`}
          onClick={() => setSearchOpened(!searchOpened)}
        >
          <BiSearchAlt size={"25"} />
          <span>SEARCH</span>
        </div>
        <SearchBar
          onCloseMenu={() => setSearchOpened(false)}
          setSearchOpened={setSearchOpened}
        />
      </div>
    );
  } else {
    return (
      <div className='horizontal_menu'>
        <ul className='horizontal_menu_ul'>{menuItemElts}</ul>
        {/* {horizontalMenuActions} */}
        <div className='search_container' onClick={() => setSearchOpened(true)}>
          <BiSearchAlt size={"25"} />
          <span>SEARCH</span>
        </div>
      </div>
    );
  }
}

function MenuItem({ item, currentLocation, onCloseMenu }) {
  const [subMenuOpened, setSubMenuOpened] = useState(false);
  const subItems = item.items || [];

  useEffect(() => {
    setSubMenuOpened(false);
  }, [currentLocation]);

  const titleContent = item.url
    ? <SiteLink to={item.url} onClick={onCloseMenu}>{item.title}</SiteLink>
    : <span>{item.title}</span>;

  return (
    <li className={`horizontal_menu_item ${subMenuOpened ? "horizontal_menu_item--open" : ""}`}>
      <div className='horizontal_menu_link'>{titleContent}</div>
      {subItems.length > 0 && (
        <ul className='horizontal_subMenu'>
          {subItems.map((subItem, index) => (
            <SubMenuItem key={index} item={subItem} onCloseMenu={onCloseMenu} level={0} />
          ))}
        </ul>
      )}
    </li>
  );
}

function SubMenuItem({ item, onCloseMenu, level: parentLevel }) {
  const level = parentLevel + 1;
  const children = item.items || [];
  const [subMenuOpened, setSubMenuOpened] = useState(false);
  const hasChildren = children.length > 0;

  function toggleSubmenu(e) {
    e.preventDefault();
    e.stopPropagation();
    setSubMenuOpened(prev => !prev);
  }

  return (
    <li className={`level__${level} navBar__subItem ${level > 1 ? "sub__level" : ""}`}>
      <SiteLink className='navBar__subLink' to={item.url} onClick={onCloseMenu}>
        <span>{item.title}</span>
        {hasChildren && (
          <span
            className={`navBar__icon__sub ${subMenuOpened ? "navBar__icon__sub--open" : ""}`}
            onClick={toggleSubmenu}
          >
            {subMenuOpened ? <FaMinus /> : <FaPlus />}
          </span>
        )}
      </SiteLink>
      {hasChildren && (
        <ul className={`level__${level + 1} navBar__subMenu ${level + 1 > 1 ? "sub__level" : ""} ${level + 1 > 6 ? "over__level" : ""} ${subMenuOpened ? "navBar__subMenu--open" : ""}`}>
          {children.map((child, index) => (
            <SubMenuItem key={index} item={child} onCloseMenu={onCloseMenu} level={level} />
          ))}
        </ul>
      )}
    </li>
  );
}
